<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24"><a-form-item label="商品名称"><a-input v-model="query.name" allow-clear placeholder="中文名 / 英文名" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="商品货号"><a-input v-model="query.sn" allow-clear /></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="上下架"><a-select v-model="query.isSale" allow-clear><a-select-option :value="1">已上架</a-select-option><a-select-option :value="0">已下架</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="5" :sm="24"><a-form-item label="排序"><a-select v-model="query.sortBy" allow-clear><a-select-option value="create_time">上架时间</a-select-option><a-select-option value="sales">销量</a-select-option><a-select-option value="collect">收藏数</a-select-option><a-select-option value="cart">购物车数</a-select-option><a-select-option value="star">评分</a-select-option></a-select></a-form-item></a-col>
            <a-col :md="2" :sm="24"><a-button type="primary" @click="search"><a-icon type="search" />查询</a-button></a-col>
          </a-row>
        </a-form>
      </div>

      <a-alert
        :type="orderType === 12 ? 'warning' : 'info'"
        show-icon
        class="scope-alert"
        :message="orderType === 3
          ? '现货：国内版和国际版阶梯价均填写人民币；国际版美元按配置汇率自动计算'
          : '定制(ODM)：无库存；国内版和国际版阶梯价均填写人民币，国际版美元按配置汇率自动计算；定制属性按订单需求选择'"
      />
      <div class="table-operations"><a-button type="primary" v-hasPermi="['dkmall:goods:add']" @click="openCreate"><a-icon type="plus" />{{ orderType === 12 ? '新增定制商品' : '新增现货商品' }}</a-button></div>
      <a-table row-key="aid" :loading="loading" :columns="displayColumns" :data-source="list" :pagination="false" bordered>
        <template slot="goods" slot-scope="text, record">
          <div class="goods-cell"><a-avatar shape="square" :size="52" :src="record.thumb" /><div><strong>{{ record.name }}</strong><div class="en-name">{{ record.nameEn || '-' }}</div></div></div>
        </template>
        <template slot="price" slot-scope="text, record">
          <a class="step-price" @click="showChildPrices(record)">{{ record.stepPriceSummary || ('¥ ' + money(record.shopPrice) + ' / $ ' + money(record.foreignPriceUsd || record.shopPriceEn)) }}</a>
        </template>
        <template slot="category" slot-scope="text, record">
          <div>{{ record.categoryPath || '-' }}</div>
        </template>
        <template slot="stats" slot-scope="text, record">
          <div>收藏 {{ record.collectNum || 0 }} · 购物车 {{ record.cartNum || 0 }}</div>
          <div class="en-name">评分 {{ record.avgStar || 0 }} · 销量 {{ record.salesNumNew || 0 }}</div>
        </template>
        <template slot="sale" slot-scope="text, record"><a-tag :color="record.isSale === 1 ? 'green' : 'default'">{{ record.isSale === 1 ? '已上架' : '已下架' }}</a-tag></template>
        <template slot="operation" slot-scope="text, record">
          <a v-hasPermi="['dkmall:goods:edit']" @click="openEdit(record)">编辑</a><a-divider type="vertical" />
          <a-popconfirm :title="record.isSale === 1 ? '确认下架该商品？' : '确认上架该商品？'" @confirm="toggleSale(record)">
            <a v-hasPermi="['dkmall:goods:edit']">{{ record.isSale === 1 ? '下架' : '上架' }}</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-popconfirm title="确认删除该商品？" @confirm="remove(record)"><a v-hasPermi="['dkmall:goods:remove']">删除</a></a-popconfirm>
        </template>
      </a-table>
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="query.pageNum" :page-size="query.pageSize" :total="total" :show-total="total => `共 ${total} 条`" @change="changePage" @showSizeChange="changePage" />

      <a-modal title="全部子商品阶梯价与计算明细" :visible="priceVisible" :footer="null" width="1000px" :body-style="{ maxHeight: '72vh', overflowY: 'auto' }" @cancel="priceVisible=false">
        <a-spin :spinning="priceLoading">
          <template v-if="!priceLoading">
            <a-alert type="info" show-icon class="price-explanation">
              <span slot="message">计算说明</span>
              <div slot="description">
                <div>购买数量落在哪一档，就使用该档配置单价；该档商品金额 = 数量 × 折后单价。</div>
                <div>列表价格区间 = 全部子商品、全部档位的最低～最高单价，再应用主商品当前有效的活动折扣。展示金额四舍五入保留两位小数。</div>
                <div>现货、定制商品新配置的国际版人民币阶梯价按汇率换算美元；旧版独立美元价保持兼容。这里不叠加企业认证优惠，不含运费。</div>
              </div>
            </a-alert>
            <a-descriptions bordered size="small" :column="1" class="price-explanation">
              <a-descriptions-item label="当前活动折扣">
                <template v-if="priceExplanation.active">优惠 {{ priceExplanation.discountRate }}%，按原价的 {{ priceExplanation.percent }} 计算</template>
                <template v-else-if="priceExplanation.expired">优惠 {{ priceExplanation.discountRate }}% 已到期，本次不参与计算</template>
                <template v-else>未设置活动折扣，配置单价即展示单价</template>
              </a-descriptions-item>
              <a-descriptions-item label="折扣前区间">¥ {{ priceExplanation.originalCnyRange }} / $ {{ priceExplanation.originalUsdRange }}</a-descriptions-item>
              <a-descriptions-item label="列表展示区间"><strong>¥ {{ priceExplanation.cnyRange }} / $ {{ priceExplanation.usdRange }}</strong>（折扣前区间 × {{ priceExplanation.percent }}）</a-descriptions-item>
            </a-descriptions>
            <div v-for="c in priceExplanation.children" :key="c.aid" class="price-child">
              <strong>{{ c.name }} / {{ c.nameEn || '-' }} · {{ c.sn || '-' }}</strong>
              <div v-if="c.baseFallback" class="hint">未配置阶梯价，列表使用基础价计算。</div>
              <a-table :data-source="c.steps" :pagination="false" :columns="priceColumns" :row-key="(r, i) => i" size="small" bordered>
                <template slot="cny" slot-scope="v, row">
                  <div>配置单价：¥ {{ row.cny.original }}</div><div>活动减免：¥ {{ row.cny.discount }}</div>
                  <strong>折后单价：¥ {{ row.cny.final }}</strong><div class="price-formula">{{ row.cny.original }} × {{ priceExplanation.percent }} = {{ row.cny.final }}</div>
                </template>
                <template slot="usd" slot-scope="v, row">
                  <div>配置单价：$ {{ row.usd.original }}</div><div>活动减免：$ {{ row.usd.discount }}</div>
                  <strong>折后单价：$ {{ row.usd.final }}</strong><div class="price-formula">{{ row.usd.original }} × {{ priceExplanation.percent }} = {{ row.usd.final }}</div>
                </template>
              </a-table>
            </div>
          </template>
        </a-spin>
      </a-modal>
      <a-modal :title="modalTitle" :visible="modalVisible" :confirm-loading="saving" width="1100px" :body-style="{ maxHeight: '72vh', overflowY: 'auto' }" @ok="submit" @cancel="closeModal">
        <a-alert message="国内版、国际版人民币阶梯价分别填写；国际版美元 = 国际版人民币 × 后台配置汇率。" type="success" show-icon class="fx-alert" />
        <a-tabs v-model="editTab">
          <a-tab-pane key="parent" :tab="orderType === 12 ? '定制主商品' : '主商品'">
            <a-form-model ref="goodsForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
              <a-row :gutter="16">
                <a-col :span="12"><a-form-model-item label="中文标题" prop="name"><a-input v-model="form.name" /></a-form-model-item></a-col>
                <a-col :span="12"><a-form-model-item label="英文标题" prop="nameEn"><a-input v-model="form.nameEn" /></a-form-model-item></a-col>
                <a-col :span="12"><a-form-model-item label="商品分类" prop="goodsCategoryId"><a-select v-model="form.goodsCategoryId" show-search option-filter-prop="children"><a-select-option v-for="item in categories" :key="item.aid" :value="item.aid">{{ item.name }} / {{ item.nameEn }}</a-select-option></a-select></a-form-model-item></a-col>

                <a-col :span="12" v-if="orderType === 3"><a-form-model-item label="主库存"><a-input-number v-model="form.stock" :min="0" style="width:100%" /></a-form-model-item></a-col>
                <a-col :span="24" v-if="orderType === 12">
                  <a-form-model-item label="定制属性" required :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }">
                    <a-select
                      v-model="attributeIdList"
                      mode="multiple"
                      allow-clear
                      placeholder="从全局定制属性中选取本商品适用项"
                      option-filter-prop="children"
                      style="width:100%"
                    >
                      <a-select-option v-for="a in customAttributes" :key="a.aid" :value="String(a.aid)">
                        {{ a.attr_name }} / {{ a.attr_name_en || '-' }}（{{ attrTypeName(a.attr_type) }}）
                      </a-select-option>
                    </a-select>
                    <div class="hint">属性标题和选项在「商品配置 → 下单定制属性」中统一维护；此处必须选取本商品下单时展示的属性。</div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="24"><a-form-model-item label="关键词" :label-col="{span:2}" :wrapper-col="{span:21}"><a-textarea v-model="form.keywords" :auto-size="{minRows:3,maxRows:8}" placeholder="支持英文逗号 , 或中文逗号 ，分隔" /></a-form-model-item></a-col>
                <a-col :span="12"><a-form-model-item label="商品主图"><file-upload :value="form.thumb" type="image" :count="1" @change="value => form.thumb = value" /><div class="hint">建议 173×173px（商品列表图），单张不超过 2MB</div></a-form-model-item></a-col>
                <a-col :span="24"><a-alert message="商品货号、价格、颜色、图集和详情请在子商品中维护。" type="info" show-icon /></a-col>
                <a-col :span="24"><a-form-model-item label="展示设置" :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }"><a-checkbox v-model="saleChecked">上架</a-checkbox></a-form-model-item></a-col>
              </a-row>
            </a-form-model>
          </a-tab-pane>
          <a-tab-pane key="children" :tab="'子商品盒子 (' + form.children.length + ')'">
            <div class="child-toolbar">
              <a-button type="dashed" icon="plus" @click="addChild">添加子商品</a-button>
              <span class="hint">按标签从左到右展示，可用“前移、后移”调整顺序，保存后生效。</span>
              <span class="hint">{{ orderType === 12 ? '定制子商品：无库存，起订量=第一档最低数量；国内、国际版分别填人民币，国际版后显示换算美元。' : '现货子商品：国内、国际版分别填人民币；国际版后显示换算美元。' }}</span>
            </div>
            <a-tabs v-if="form.children.length" v-model="activeChildTab" type="card" class="child-tabs">
              <a-tab-pane v-for="(child, idx) in form.children" :key="child._tabKey">
                <span slot="tab" class="child-tab-title" :title="(child.name || '未命名子商品') + (child.sn ? ' · ' + child.sn : '')">{{ idx + 1 }}. {{ child.name || '未命名子商品' }}{{ child.sn ? ' · ' + child.sn : '' }}</span>
                <div class="child-actions">
                  <a-button size="small" :disabled="idx===0" @click="moveChild(idx,-1)">前移</a-button>
                  <a-button size="small" :disabled="idx===form.children.length-1" @click="moveChild(idx,1)">后移</a-button>
                  <a-button type="danger" size="small" ghost @click="removeChild(idx)">移除</a-button>
                </div>
                <section class="child-section">
                  <h4>基本信息</h4>
                  <div class="child-grid child-grid-three">
                    <div class="child-field"><div class="field-label">中文标题</div><a-input v-model="child.name" /></div>
                    <div class="child-field"><div class="field-label">英文标题</div><a-input v-model="child.nameEn" /></div>
                    <div class="child-field"><div class="field-label">货号</div><a-input v-model="child.sn" /></div>
                  </div>
                  <div class="child-grid">
                    <div class="child-field"><div class="field-label">筛选颜色</div><a-select :value="childColorValues(child)" mode="multiple" allow-clear style="width:100%" @change="v => $set(child, 'colorIds', v.join(','))"><a-select-option v-for="color in filterColors" :key="color.aid" :value="String(color.aid)"><span class="color-dot" :style="{background: color.colour || '#ccc'}" />{{ color.name }} / {{ color.name_en || color.nameEn || '-' }}</a-select-option></a-select></div>
                  </div>
                </section>
                <section class="child-section">
                  <h4>行业属性 <a-button size="small" :disabled="industryLoading || industryError" @click="addIndustryRow(child)">新增行业属性</a-button><a-button size="small" type="link" :loading="industryLoading" @click="loadIndustry">刷新配置</a-button></h4>
                  <a-alert v-if="industryError" message="行业属性配置加载失败，请刷新配置后选择。" type="warning" show-icon />
                  <a-table class="industry-fields" :columns="industryColumns" :data-source="child._industryRows || []" :pagination="false" :row-key="row=>row._key" :locale="{emptyText:'暂无关联行业属性，点击上方新增'}" size="small" bordered>
                    <template slot="definition" slot-scope="_,row"><a-select :value="row.libraryId" allow-clear show-search option-filter-prop="children" style="width:100%" placeholder="从商品行业属性选择" :loading="industryLoading" @change="id=>changeIndustryDefinition(child,row,id)"><a-select-option v-for="d in industryDefinitionOptions(child,row)" :key="d.aid" :value="Number(d.aid)" :disabled="Number(d.status)!==1 || Number(d.is_del)===1">{{ d.title }} / {{ d.title_en }}</a-select-option></a-select></template>
                    <template slot="values" slot-scope="_,row">
                      <div v-if="row.pairs && row.pairs[0]" class="industry-values">
                        <div class="industry-value-pair">
                          <a-select
                            :value="row.pairs[0].optionId"
                            allow-clear
                            show-search
                            option-filter-prop="children"
                            style="width:100%"
                            placeholder="下拉选择配置值（选后中英自动填入）"
                            :disabled="!row.libraryId"
                            @change="id => pickIndustryPairOption(child, row, row.pairs[0], id)"
                          >
                            <a-select-option
                              v-for="v in industryValueOptions(row)"
                              :key="'opt-'+v.aid"
                              :value="Number(v.aid)"
                              :disabled="Number(v.status)!==1 || Number(v.is_del)===1"
                            >{{ v.content }} / {{ v.content_en || '未配置英文' }}</a-select-option>
                          </a-select>
                          <div class="industry-custom-pair">
                            <a-input
                              v-model="row.pairs[0].content"
                              placeholder="属性值中文"
                              :disabled="!row.libraryId"
                              @change="() => onIndustryPairEdit(child, row.pairs[0])"
                            />
                            <a-input
                              v-model="row.pairs[0].contentEn"
                              placeholder="属性值英文"
                              :disabled="!row.libraryId"
                              @change="() => onIndustryPairEdit(child, row.pairs[0])"
                            />
                          </div>
                        </div>
                        <div class="hint">行业属性与属性值一对一；下拉选择后自动填入中英文，也可直接手填（都要填）</div>
                      </div>
                    </template>
                    <template slot="action" slot-scope="_,row"><a @click="removeIndustryRow(child,row)">移除</a></template>
                  </a-table>
                </section>
                <section class="child-section">
                  <h4>{{ orderType === 3 ? '价格与库存' : '商品与样品价格' }}</h4>
                  <div class="child-grid">
                    <div class="child-field"><div class="field-label">国内版基础价 CNY</div><a-input-number v-model="child.shopPrice" :min="0" :precision="2" style="width:100%" /></div>
                    <div class="child-field"><div class="field-label">国际版基础价 CNY</div><a-input-number v-model="child.shopPriceEn" :min="0" :precision="2" style="width:100%" /><div class="hint">USD ≈ {{ money(previewUsd(child.shopPriceEn)) }}</div></div>
                    <div class="child-field" v-if="orderType === 3"><div class="field-label">库存</div><a-input-number v-model="child.stock" :min="0" style="width:100%" /></div>
                    <div class="child-field" v-if="orderType === 12"><div class="field-label">国内版样品价 CNY</div><a-input-number v-model="child.samplePrice" :min="0" :precision="2" style="width:100%" /></div>
                    <div class="child-field" v-if="orderType === 12"><div class="field-label">国际版样品价 CNY</div><a-input-number v-model="child.samplePriceForeignCny" :min="0" :precision="2" style="width:100%" /><div class="hint">USD ≈ {{ money(previewUsd(child.samplePriceForeignCny)) }}</div></div>
                  </div>
                </section>
                <section class="child-section">
                  <h4>重量与运费</h4>
                  <div class="child-grid">
                    <div class="child-field"><div class="field-label">实重(KG)</div><a-input-number :value="weightKg(child)" :min="0" :precision="3" :step="0.001" style="width:100%" @change="v => updateWeightKg(child, v)" /></div>
                    <div class="child-field"><div class="field-label">包装体积(cm³)</div><a-input-number v-model="child.packageVolumeCm3" :min="0" :precision="2" placeholder="单件包装后的体积" style="width:100%" /></div>
                  </div>
                  <div class="child-grid">
                    <div class="child-field"><div class="field-label">国内运费模板</div><a-select v-model="child.freightTemplateId" placeholder="使用默认快递模板" style="width:100%" @change="() => $set(child, 'isShipping', 0)"><a-select-option value="0">使用默认快递模板</a-select-option><a-select-option v-for="f in freightTemplates.filter(t => Number(t.freight_type) === 1)" :key="f.aid" :value="String(f.aid)">{{ f.name }}</a-select-option></a-select></div>
                    <div class="child-field"><div class="field-label">运费设置</div><div class="child-freight-controls"><a-checkbox :checked="Number(child.isShipping) === 1" @change="e => { $set(child, 'isShipping', e.target.checked ? 1 : 0); if (e.target.checked) $set(child, 'freightPrice', 0) }">包邮</a-checkbox><span class="hint">未勾选时可填固定运费，或按模板+重量体积计算</span></div></div>
                    <div class="child-field" v-if="Number(child.isShipping) !== 1"><div class="field-label">固定运费（测试用）</div><a-input-number v-model="child.freightPrice" :min="0" :precision="2" style="width:100%" placeholder="填写后下单优先用该运费" /><div class="hint">便于联调；留空则按运费模板自动计算</div></div>
                  </div>
                </section>
                <section class="child-section">
                  <h4>图片与视频</h4>
                  <div class="child-grid">
                    <div class="child-field"><div class="field-label">主图（子商品封面）</div><file-upload :value="child.thumb" type="image" :count="1" @change="v => child.thumb = v" /><div class="hint">用于选择子商品时的缩略图，不占图集图片额度。建议 173×173px（商品列表图），单张不超过 2MB。</div></div>
                    <div class="child-field"><div class="field-label">图集（图片 / 视频）</div><file-upload :value="childGallery(child)" type="media" :count="10" :max-images="9" @change="v => updateChildGallery(child, v)" /><div class="hint">商品详情顶部轮播图建议 375×375px（宽×高）。统一上传图片与视频，最多 9 张图片和 1 个视频；图片 2MB，MP4 / WebM 视频 50MB。视频封面自动生成。</div></div>
                  </div>
                </section>
                <section class="child-section">
                    <div class="field-label">商品详情</div>
                    <editor
                      v-if="modalVisible && editTab === 'children' && activeChildTab === child._tabKey"
                      :key="'child-body-' + idx + '-' + (child.aid || 'new')"
                      v-model="child.body"
                      :height="240"
                      :z-index="10050"
                    />
                    <div class="hint">可视化编辑：详情图片建议宽 750px、高度自适应，单张不超过 2MB。</div>
                </section>

                <div class="section-title">阶梯价（国内版人民币 / 国际版人民币）<a-button size="small" type="link" @click="addStep(child)">+ 档位</a-button></div>
                <div v-for="(step, si) in child.stepPrices" :key="'s'+si" class="step-row">
                  <a-input-number v-model="step.minStepnum" :min="1" placeholder="起订" />
                  <span>~</span>
                  <a-input-number v-model="step.maxStepnum" :min="1" placeholder="上限" />
                  <label>国内版 ¥ <a-input-number v-model="step.priceCny" :min="0" :precision="2" placeholder="人民币 CNY" /></label>
                  <label>国际版 ¥ <a-input-number v-model="step.priceForeignCny" :min="0" :precision="2" placeholder="人民币 CNY" /></label><span class="usd-preview">≈ $ {{ step.priceForeignCny == null ? '—' : money(previewUsd(step.priceForeignCny)) }}</span>
                  <a @click="child.stepPrices.splice(si, 1)">删</a>
                </div>
                <div v-if="orderType === 12 && child.stepPrices.length" class="hint">起订量 = 第一档 {{ child.stepPrices[0].minStepnum || '-' }}</div>

                <div class="section-title">发货时效规则<a-button size="small" type="link" @click="addShip(child)">+ 规则</a-button></div>
                <div v-for="(rule, ri) in child.shipRules" :key="'r'+ri" class="step-row ship-rule-row">
                  <label>数量 ≥ <a-input-number v-model="rule.number" :min="1" placeholder="件数≥" /> 件</label>
                  <label>发货天数 <a-input-number v-model="rule.days" :min="0" placeholder="天数" /> 天</label>
                  <a @click="child.shipRules.splice(ri, 1)">删</a>
                </div>
                <div class="hint" v-if="orderType === 3">现货：库存内可按 1 天发（业务约定）；不足库存走上方配置天数。</div>
              </a-tab-pane>
            </a-tabs>
            <a-empty v-else description="尚未添加子商品" />
          </a-tab-pane>
        </a-tabs>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageGoods, setGoodsSale, listCategories, getGoods, addGoods, updateGoods, deleteGoods } from '@/api/dkmall/catalog'
import { freightOptions } from '@/api/dkmall/freight'
import { listAttributes, listIndustrySelection } from '@/api/dkmall/catalog-config'
import { legacyPage } from '@/api/dkmall/legacy'
import Editor from '@/components/Editor'
import { explainStepPrices } from './priceExplanation'

let childTabSequence = 0
const emptyChild = () => ({
  _tabKey: 'child-' + (++childTabSequence),
  aid: undefined, name: '', nameEn: '', sn: '', thumb: '', images: '', colorIds: '', warmPrompt: '', stock: 0,
  shopPrice: 0, shopPriceEn: 0, samplePrice: 0, samplePriceForeignCny: 0, video: '', videoImg: '', freightTemplateId: '0', freightPrice: 0, isShipping: 1, packageVolumeCm3: undefined, weight: 0, kWeight: 0, wWeight: 0, body: '',
  isSale: 1, status: 1, sort: 100, industryValueIds: [], industryCustomValues: [], _industryRows: [],
  stepPrices: [{ minStepnum: 1, maxStepnum: 100, priceCny: 0, priceForeignCny: undefined, priceUsd: undefined }],
  shipRules: [{ number: 1, days: 1 }]
})

const emptyForm = orderType => ({
  aid: undefined, orderType, name: '', nameEn: '', sn: '', goodsCategoryId: undefined,
  thumb: '', images: '', keywords: '', warmPrompt: '', colorIds: '', customAttributeIds: '',
  stock: 0, shopPrice: 0, shopPriceEn: 0, foreignPriceUsd: 0, samplePrice: 0,
  freightTemplateId: '0', freightPrice: 0, isShipping: 0,
  isSale: 0, isNew: 0, isHot: 0, isRecommend: 0, status: 1, sort: 100, body: '',
  children: []
})

export default {
  name: 'DkMallGoods',
  components: { Editor },
  data() {
    return {
      priceVisible: false, priceLoading: false, priceChildren: [], priceGoods: {}, priceNow: 0,
      industryDefinitions: [], industryLoading: false, industryError: false, industryRequest: 0,
      industryColumns: [{title:'行业属性',width:'28%',scopedSlots:{customRender:'definition'}},{title:'属性值',scopedSlots:{customRender:'values'}},{title:'操作',width:70,scopedSlots:{customRender:'action'}}],
      priceColumns: [{title:'起订量',dataIndex:'minStepnum'},{title:'上限数量',dataIndex:'maxStepnum'},{title:'国内版人民币 CNY',dataIndex:'priceCny',scopedSlots:{customRender:'cny'}},{title:'国际版美元 USD',dataIndex:'priceUsd',scopedSlots:{customRender:'usd'}}],
      loading: false,
      list: [],
      total: 0,
      modalVisible: false,
      saving: false,
      editTab: 'parent',
      activeChildTab: '',
      usdRate: 0.14,
      categories: [],
      freightTemplates: [],
      customAttributes: [],
      filterColors: [],
      colorIdList: [],
      attributeIdList: [],
      form: emptyForm(3),
      rules: {
        name: [{ required: true, message: '请输入中文标题' }],
        nameEn: [{ required: true, message: '请输入英文标题' }],
        goodsCategoryId: [{ required: true, message: '请选择商品分类' }]
      },
      query: { pageNum: 1, pageSize: 15, name: undefined, sn: undefined, isSale: undefined, sortBy: 'create_time' },
      baseColumns: [
        { title: '商品', scopedSlots: { customRender: 'goods' }, width: 280 },
        { title: '分类', scopedSlots: { customRender: 'category' }, width: 180 },
        { title: '子商品货号', dataIndex: 'childSns', width: 220 },
        { title: '阶梯价', scopedSlots: { customRender: 'price' }, width: 260 },
        { title: '库存', dataIndex: 'stock', width: 80, align: 'center', key: 'stock' },
        { title: '数据', scopedSlots: { customRender: 'stats' }, width: 180 },
        { title: '上下架', scopedSlots: { customRender: 'sale' }, width: 90, align: 'center' },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 210, align: 'center' }
      ]
    }
  },
  computed: {
    priceExplanation() { return explainStepPrices(this.priceGoods, this.priceChildren, this.usdRate, this.priceNow) },
    orderType() { return String(this.$route.path).toLowerCase().includes('custom-goods') ? 12 : 3 },
    modalTitle() {
      const kind = this.orderType === 12 ? '定制商品' : '现货商品'
      return (this.form.aid ? '编辑' : '新增') + kind
    },
    displayColumns() {
      return this.baseColumns.filter(c => c.key !== 'stock')
    },
    domesticFreightTemplates() {
      return (this.freightTemplates || []).filter(t => Number(t.freight_type) === 1 || t.freight_type == null)
    },
    saleChecked: { get() { return this.form.isSale === 1 }, set(v) { this.form.isSale = v ? 1 : 0 } },
    newChecked: { get() { return this.form.isNew === 1 }, set(v) { this.form.isNew = v ? 1 : 0 } },
    recommendChecked: { get() { return this.form.isRecommend === 1 }, set(v) { this.form.isRecommend = v ? 1 : 0 } },
    // is_shipping: 1=包邮(不算运费), 0=按运费模板计费
    shippingFreeChecked: {
      get() { return Number(this.form.isShipping) === 1 },
      set(v) { this.form.isShipping = v ? 1 : 0 }
    }
  },
  watch: { '$route.fullPath': 'load' },
  created() { this.load() },
  methods: {
    showChildPrices(record) {
      this.priceVisible = true
      this.priceLoading = true
      this.priceChildren = []
      getGoods(record.aid, this.orderType).then(r => {
        const detail = r.data || {}
        this.priceGoods = { ...record, ...(detail.goods || {}) }
        this.priceChildren = detail.children || []
        this.usdRate = Number(detail.usdRate || this.usdRate)
        this.priceNow = Date.now() / 1000
      }).catch(() => { this.priceVisible = false }).finally(() => { this.priceLoading = false })
    },
    weightKg(child) { return Number(child.weight || 0) / 1000 },
    updateWeightKg(child, value) { this.$set(child, 'weight', Math.round(Math.max(0, Number(value) || 0) * 1000)) },
    childGallery(child) { return [...new Set([...(child.images || '').split(','), child.video].filter(Boolean))].join(',') },
    updateChildGallery(child, value) {
      const urls = String(typeof value === 'string' ? value : value.path || '').split(',').filter(Boolean)
      const videos = urls.filter(v => /\.(mp4|webm)(?:[?#]|$)/i.test(v))
      if (videos.length > 1) return this.$message.warning('每个子商品图集保留一个视频')
      if (urls.length - videos.length > 9) return this.$message.warning('每个子商品图集最多 9 张图片')
      this.$set(child, 'images', urls.filter(v => !videos.includes(v)).join(','))
      this.$set(child, 'video', videos[0] || '')
      this.$set(child, 'videoImg', videos[0] ? videos[0].split('?')[0] + '?x-oss-process=video/snapshot,t_1000,f_jpg' : '')
    },
    childColorValues(child) { return String(child.colorIds || '').split(',').filter(Boolean) },
    load() {
      this.loading = true
      pageGoods({ ...this.query, orderType: this.orderType }).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = Number((res.data && res.data.total) || 0)
      }).finally(() => { this.loading = false })
    },
    search() { this.query.pageNum = 1; this.load() },
    changePage(page, pageSize) { this.query.pageNum = page; this.query.pageSize = pageSize; this.load() },
    money(value) { return Number(value || 0).toFixed(2) },
    previewUsd(cny) { return Number(cny || 0) * Number(this.usdRate || 0) },
    syncParentUsd() {
      const cny = this.form.shopPrice
      this.form.shopPrice = cny
      this.form.foreignPriceUsd = this.previewUsd(cny)
    },
    toggleSale(record) { setGoodsSale(record.aid, record.isSale !== 1).then(() => { this.$message.success('状态已更新'); this.load() }) },
    loadCategories() { listCategories(this.orderType === 3 ? 'DK' : 'CUSTOM').then(res => { this.categories = res.data || [] }) },
    loadFreight() { freightOptions().then(res => { this.freightTemplates = res.data || [] }) },
    loadCustomAttributes() {
      if (this.orderType !== 12) { this.customAttributes = []; return Promise.resolve() }
      return listAttributes(1).then(res => { this.customAttributes = (res.data || []).filter(a => Number(a.status) !== 0) })
        .catch(() => { this.customAttributes = [] })
    },
    attrTypeName(v) { return ({ 1: '单选', 2: '多选', 3: '是否', 4: '文本' })[Number(v)] || v },
    onFreightTemplateChange(value) {
      if (value && value !== '0') {
        this.form.isShipping = 0
      }
    },
    loadFilterColors() {
      legacyPage('filter-color', { pageNum: 1, pageSize: 200 }).then(res => {
        this.filterColors = (res.data && res.data.rows) || []
      }).catch(() => { this.filterColors = [] })
    },
    syncColorIds() {
      this.form.colorIds = (this.colorIdList || []).join(',')
    },
    syncAttributeIds() {
      this.form.customAttributeIds = (this.attributeIdList || []).join(',')
    },
    async loadIndustry() {
      const request = ++this.industryRequest
      this.industryLoading = true
      this.industryError = false
      try { const r = await listIndustrySelection(this.orderType); if (request === this.industryRequest) { this.industryDefinitions = r.data || []; this.hydrateIndustryRows() } }
      catch (_) { if (request === this.industryRequest) { this.industryDefinitions = []; this.industryError = true } }
      finally { if (request === this.industryRequest) this.industryLoading = false }
    },
    emptyIndustryPair() {
      return { optionId: undefined, content: '', contentEn: '' }
    },
    /** 行业属性与属性值一对一：每行强制只保留一个 pair */
    ensureIndustryPair(row) {
      if (!row.pairs || !row.pairs.length) {
        this.$set(row, 'pairs', [this.emptyIndustryPair()])
      } else if (row.pairs.length > 1) {
        row.pairs.splice(1)
      }
      return row.pairs[0]
    },
    hydrateIndustryRows() {
      this.form.children.forEach(child => {
        if (child._industryRows != null) return
        const selected = (child.industryValueIds || []).map(Number)
        const customs = child.industryCustomValues || []
        this.$set(child, '_industryRows', this.industryDefinitions.map(d => {
          const fromOptions = (d.values || [])
            .filter(v => selected.includes(Number(v.aid)))
            .map(v => ({
              optionId: Number(v.aid),
              content: v.content || '',
              contentEn: v.content_en || v.contentEn || ''
            }))
          const fromCustoms = customs
            .filter(v => Number(v.libraryId) === Number(d.aid))
            .map(v => ({
              optionId: undefined,
              content: v.content || '',
              contentEn: v.contentEn || v.content_en || ''
            }))
          // 一对一：同一属性只取第一个已选/手填值
          const pairs = [...fromOptions, ...fromCustoms].slice(0, 1)
          return {
            _key: 'industry-' + (++childTabSequence),
            libraryId: Number(d.aid),
            pairs
          }
        }).filter(row => row.pairs.length))
      })
    },
    addIndustryRow(child) {
      if (!child._industryRows) this.$set(child, '_industryRows', [])
      child._industryRows.push({
        _key: 'industry-' + (++childTabSequence),
        libraryId: undefined,
        pairs: [this.emptyIndustryPair()]
      })
    },
    industryDefinitionOptions(child, row) {
      return this.industryDefinitions.filter(d =>
        Number(d.aid) === row.libraryId ||
        (Number(d.status) === 1 && Number(d.is_del) !== 1 && !(child._industryRows || []).some(r => r !== row && r.libraryId === Number(d.aid)))
      )
    },
    industryValueOptions(row) {
      const d = this.industryDefinitions.find(item => Number(item.aid) === row.libraryId)
      const pair = (row.pairs && row.pairs[0]) || {}
      return ((d && d.values) || []).filter(v =>
        (Number(d.status) === 1 && Number(d.is_del) !== 1 && Number(v.status) === 1 && Number(v.is_del) !== 1) ||
        Number(pair.optionId) === Number(v.aid)
      )
    },
    changeIndustryDefinition(child, row, id) {
      row.libraryId = id == null ? undefined : Number(id)
      this.$set(row, 'pairs', [this.emptyIndustryPair()])
      this.syncIndustrySelections(child)
    },
    pickIndustryPairOption(child, row, pair, id) {
      const target = pair || this.ensureIndustryPair(row)
      if (id == null || id === undefined || id === '') {
        target.optionId = undefined
        target.content = ''
        target.contentEn = ''
        this.syncIndustrySelections(child)
        return
      }
      const optionId = Number(id)
      const options = this.industryValueOptions(row)
      const found = options.find(v => Number(v.aid) === optionId)
      target.optionId = optionId
      target.content = (found && found.content) || ''
      target.contentEn = (found && (found.content_en || found.contentEn)) || ''
      this.syncIndustrySelections(child)
    },
    onIndustryPairEdit(child, pair) {
      // 改过带出的中英后，视为手填，不再绑定配置项 id
      if (pair.optionId) {
        const d = this.industryDefinitions.find(item =>
          (item.values || []).some(v => Number(v.aid) === Number(pair.optionId))
        )
        const found = d && (d.values || []).find(v => Number(v.aid) === Number(pair.optionId))
        const originCn = (found && found.content) || ''
        const originEn = (found && (found.content_en || found.contentEn)) || ''
        if (String(pair.content || '').trim() !== String(originCn).trim() ||
          String(pair.contentEn || '').trim() !== String(originEn).trim()) {
          pair.optionId = undefined
        }
      }
      this.syncIndustrySelections(child)
    },
    syncIndustrySelections(child) {
      const known = this.industryDefinitions.flatMap(d => (d.values || []).map(v => Number(v.aid)))
      const unknown = (child.industryValueIds || []).map(Number).filter(id => !known.includes(id))
      const configured = []
      const custom = []
      ;(child._industryRows || []).forEach(row => {
        if (!row.libraryId) return
        const pair = this.ensureIndustryPair(row)
        const content = String(pair.content || '').trim()
        const contentEn = String(pair.contentEn || '').trim()
        if (!content && !contentEn) return
        // 仍绑定配置项且中英未改 → 走配置 id；否则按手填存中英文
        if (pair.optionId) {
          const d = this.industryDefinitions.find(item => Number(item.aid) === Number(row.libraryId))
          const found = d && (d.values || []).find(v => Number(v.aid) === Number(pair.optionId))
          const originCn = (found && found.content) || ''
          const originEn = (found && (found.content_en || found.contentEn)) || ''
          if (found && content === String(originCn).trim() && contentEn === String(originEn).trim()) {
            configured.push(Number(pair.optionId))
            return
          }
          pair.optionId = undefined
        }
        custom.push({ libraryId: row.libraryId, content, contentEn })
      })
      this.$set(child, 'industryValueIds', [...new Set([...unknown, ...configured])])
      this.$set(child, 'industryCustomValues', custom)
    },
    removeIndustryRow(child, row) {
      child._industryRows.splice(child._industryRows.indexOf(row), 1)
      this.syncIndustrySelections(child)
    },
    openCreate() {
      this.form = emptyForm(this.orderType)
      this.colorIdList = []
      this.attributeIdList = []
      this.editTab = 'parent'
      this.activeChildTab = ''
      this.loadCategories()
      this.loadFreight()
      this.loadFilterColors()
      this.loadCustomAttributes()
      this.loadIndustry()
      this.modalVisible = true
    },
    openEdit(record) {
      this.industryDefinitions = []
      this.loadIndustry()
      this.loadCategories()
      this.loadFreight()
      this.loadFilterColors()
      this.loadCustomAttributes()
      getGoods(record.aid, this.orderType).then(res => {
        const g = (res.data && res.data.goods) || {}
        this.usdRate = Number((res.data && res.data.usdRate) || 0.14)
        const children = ((res.data && res.data.children) || []).map(c => ({
          ...emptyChild(),
          ...c,
          _industryRows: null,
          industryValueIds: c.industryValueIds == null ? undefined : c.industryValueIds.map(Number),
          samplePrice: c.samplePrice != null ? c.samplePrice : c.shopPrice,
          shopPriceEn: c.shopPriceEn != null ? c.shopPriceEn : c.shopPrice,
          samplePriceForeignCny: c.samplePriceForeignCny != null ? c.samplePriceForeignCny : (c.samplePriceUsd != null ? Number((Number(c.samplePriceUsd)/this.usdRate).toFixed(2)) : (c.samplePrice != null ? c.samplePrice : c.shopPrice)),
          stepPrices: (c.stepPrices && c.stepPrices.length) ? c.stepPrices.map(s => ({ ...s, priceForeignCny: s.priceForeignCny != null ? s.priceForeignCny : (s.priceUsd != null ? Number((Number(s.priceUsd) / this.usdRate).toFixed(2)) : s.priceCny) })) : emptyChild().stepPrices,
          shipRules: (c.shipRules && c.shipRules.length) ? c.shipRules : emptyChild().shipRules
        }))
        this.usdRate = Number((res.data && res.data.usdRate) || 0.14)
        const colorIds = g.freefiltercolorsId || ''
        this.colorIdList = colorIds ? String(colorIds).split(',').filter(Boolean) : []
        const attrIds = g.customAttributeIds || ''
        const fromDetail = (res.data && res.data.customAttributeIds) || []
        this.attributeIdList = attrIds
          ? String(attrIds).split(',').filter(Boolean)
          : fromDetail.map(String)
        this.form = {
          ...emptyForm(this.orderType),
          ...g,
          freightTemplateId: String(g.freightTemplateId || '0'),
          body: (res.data && res.data.body) || '',
          warmPrompt: g.warmPrompt || '',
          colorIds,
          customAttributeIds: attrIds || this.attributeIdList.join(','),
          samplePrice: g.samplePrice != null ? g.samplePrice : g.shopPrice || 0,
          children
        }
        this.editTab = 'parent'
        this.activeChildTab = children.length ? children[0]._tabKey : ''
        if (!this.industryLoading && !this.industryError) this.hydrateIndustryRows()
        this.modalVisible = true
      })
    },
    closeModal() { this.modalVisible = false; this.form = emptyForm(this.orderType); this.attributeIdList = [] },
    changeImages(value) { this.form.images = typeof value === 'string' ? value : (value.path || '') },
    addChild() {
      this.form.children.push(emptyChild())
      this.activeChildTab = this.form.children[this.form.children.length - 1]._tabKey
      this.editTab = 'children'
    },
    moveChild(idx,offset) {
      const target=idx+offset
      if(target<0 || target>=this.form.children.length)return
      const child=this.form.children.splice(idx,1)[0]
      this.form.children.splice(target,0,child)
    },
    removeChild(idx) {
      const removed = this.form.children.splice(idx, 1)[0]
      if (removed && removed._tabKey === this.activeChildTab) {
        const next = this.form.children[Math.min(idx, this.form.children.length - 1)]
        this.activeChildTab = next ? next._tabKey : ''
      }
    },
    addStep(child) { child.stepPrices.push({ minStepnum: 1, maxStepnum: 100, priceCny: 0, priceForeignCny: undefined, priceUsd: undefined }) },
    addShip(child) { child.shipRules.push({ number: 1, days: 1 }) },
    submit() {
      // 提交前再同步一遍手填中英文，避免输入框未失焦时漏存
      ;(this.form.children || []).forEach(child => this.syncIndustrySelections(child))
      this.$refs.goodsForm.validate(valid => {
        if (!valid) { this.editTab = 'parent'; return }
        if (this.orderType === 12 && !this.attributeIdList.length) {
          this.editTab = 'parent'
          this.$message.warning('定制商品至少选择一个定制属性')
          return
        }
        for (let i = 0; i < this.form.children.length; i++) {
          const c = this.form.children[i]
          const prices=this.orderType===12?[c.shopPrice,c.shopPriceEn,c.samplePrice,c.samplePriceForeignCny]:[c.shopPrice,c.shopPriceEn]
          if(prices.some(v=>v==null || !Number.isFinite(Number(v)) || Number(v)<0)){
            this.editTab='children';this.activeChildTab=c._tabKey;this.$message.warning('请分别填写国内版和国际版的基础价、样品价');return
          }
          if ((c._industryRows || []).some(row=>!row.libraryId)) {
            this.editTab='children';this.activeChildTab=c._tabKey;this.$message.warning('请完善行业属性关联行，或移除未选择的行');return
          }
          const incompletePair = (c._industryRows || []).some(row => {
            const item = (row.pairs && row.pairs[0]) || {}
            const cn = String(item.content || '').trim()
            const en = String(item.contentEn || '').trim()
            return (cn && !en) || (!cn && en)
          })
          if (incompletePair) {
            this.editTab = 'children'
            this.activeChildTab = c._tabKey
            this.$message.warning('属性值需同时填写中文和英文')
            return
          }
          if (!c.name || !c.nameEn) {
            this.editTab = 'children'
            this.activeChildTab = c._tabKey
            this.$message.warning('请完善第 ' + (i + 1) + ' 个子商品的中英文标题')
            return
          }
        }
        for (let i = 0; i < this.form.children.length; i++) {
          if (this.form.children[i].stepPrices.some(s => s.priceCny == null || s.priceForeignCny == null || s.priceCny < 0 || s.priceForeignCny < 0)) {
            this.editTab = 'children'
            this.activeChildTab = this.form.children[i]._tabKey
            this.$message.warning('请分别填写第 ' + (i + 1) + ' 个子商品的国内版和国际版阶梯价')
            return
          }
        }
        if (this.orderType === 12) {
          // 样品价格独立保存，不覆盖普通商品价格
          this.form.stock = 0
          this.form.freightPrice = 0
          this.form.children.forEach(c => {
            // 保留普通商品价格
            c.stock = 0
          })
          this.syncAttributeIds()
        } else {
          this.form.customAttributeIds = ''
        }
        this.form.keywords = String(this.form.keywords || "").split(/[,，]/).map(v => v.trim()).filter(Boolean).join(",")
        this.syncColorIds()
        this.syncParentUsd()
        if (this.form.freightTemplateId && this.form.freightTemplateId !== '0' && Number(this.form.isShipping) === 1) {
          this.$message.warning('已选运费模板但仍勾选包邮，商城将不计运费；如需计费请取消包邮')
        }
        this.form.isShipping = Number(this.form.isShipping) === 1 ? 1 : 0
        this.saving = true
        const payload = { ...this.form, children: this.form.children.map(({ _tabKey, _industryRows, ...child },index) => ({ ...child, sort:index+1, stepPrices: child.stepPrices.map(step => ({ ...step, priceUsd: Number(this.money(this.previewUsd(step.priceForeignCny))) })) })) }
        const req = this.form.aid ? updateGoods(payload) : addGoods(payload)
        req.then(() => { this.$message.success('保存成功'); this.closeModal(); this.load() })
          .finally(() => { this.saving = false })
      })
    },
    remove(record) { deleteGoods(record.aid, this.orderType).then(() => { this.$message.success('删除成功'); this.load() }) }
  }
}
</script>

<style scoped>
.child-tab-title { display:inline-block;max-width:230px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:bottom; }
.child-tabs { margin-top:16px; }
.scope-alert { margin-bottom: 16px; }
.fx-alert { margin-bottom: 12px; }
.goods-cell { display: flex; gap: 12px; align-items: center; }
.en-name { color: #8c8c8c; margin-top: 4px; }
.step-price { font-size: 12px; line-height: 1.5; white-space: normal; }
.price-explanation { margin-bottom: 16px; }
.price-explanation .ant-alert-description > div + div { margin-top: 6px; }
.price-child { margin-bottom: 20px; }
.price-child > strong { display: block; margin-bottom: 8px; }
.price-formula { color: #8c8c8c; font-size: 12px; margin-top: 4px; }
.hint { color: #8c8c8c; font-size: 12px; margin-top: 4px; }
.child-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 12px; margin-bottom: 12px; }
.child-actions { display: flex; justify-content: flex-end; gap: 8px; margin-bottom: 12px; }
.child-section { margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #f0f0f0; }
.child-section h4 { font-size: 14px; font-weight: 600; margin: 0 0 12px; }
.child-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; align-items: start; }
.child-grid + .child-grid { margin-top: 16px; }
.child-grid-three { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.child-field { min-width: 0; }
.child-field .field-label { margin-top: 0; min-height: 18px; }
.child-freight-controls { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; min-height: 32px; }
@media (max-width: 800px) { .child-grid-three { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 600px) { .child-grid, .child-grid-three { grid-template-columns: minmax(0, 1fr); } }
.field-label { font-size: 12px; color: #595959; margin: 8px 0 4px; }
.section-title { margin: 16px 0 8px; font-weight: 600; }
.step-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; flex-wrap: wrap; }
.ship-rule-row label { display:flex;align-items:center;gap:8px;font-weight:400; }
.usd-preview { color: #389e0d; min-width: 90px; }
.color-dot { display: inline-block; width: 12px; height: 12px; border-radius: 2px; margin-right: 6px; vertical-align: middle; border: 1px solid #d9d9d9; }
.industry-values { display: flex; flex-direction: column; gap: 8px; }
.industry-value-pair { display: flex; flex-direction: column; gap: 6px; }
.industry-custom-pair { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; align-items: center; }
</style>
